export default class RandomMiniIcons {
  constructor(selector, icons) {
    this.images = document.querySelectorAll(selector);
    this.icons = icons;

    this.init();
  }

  init() {
    // console.log("✅ RandomMiniIcons init() appelé");
    // console.log("Images trouvées :", this.images.length);
    // console.log("Icons reçus :", this.icons.length);
    // console.log("Premier icon :", this.icons[0]);

    const shuffledIcons = this.shuffleArray([...this.icons]);

    this.images.forEach((image, index) => {
      const icon = shuffledIcons[index];
      console.log(`Image ${index} :`, image);
      console.log(`Icon ${index} :`, icon);


      if (!icon) return;

      image.src = icon.file;
      console.log(`→ src assigné :`, image.src);
      image.alt = `Icône ${icon.name}`;
    });
  }

  shuffleArray(array) {
    return array.sort(() => Math.random() - 0.5);
  }
}